import { useEffect, FC } from 'react';
import { ApiKeyTemplatePageView } from './apiKeyTemplatePageView';
import { useListStore } from './hooks';

export const ApiKeyTemplatePage: FC = () => {
  const { fetchApiKeyTemplates } = useListStore();

  useEffect(() => {
    void fetchApiKeyTemplates();
  }, [fetchApiKeyTemplates]);

  return <ApiKeyTemplatePageView />;
};
